/**
 * This represents an advertisement to be displayed
 */
export class Advertisement {
    id: number;
    name: string;
    companyName: string;
    active: boolean;
    startDate: Date;
    endDate: Date;
    displayPeriod: number;
    rank: number;
    useIn: string [];
    externalUrl: string;
    imageUrl: string;
    updateCounter: number;
    autoInclude: boolean;
}



// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/models/mygolf/advertisement/advertisement.ts